import { getLoggedInUser, getAuthToken, fetchCheckoutLink, getAppRuntimeConstants, updateDownloadLinksWithVersion, getIpInfo, countryCodeToRegionClass, logUserActivity } from './utils'

const checkoutSuccessUrl = 'https://musesessions.co/spark-confirmation'
const checkoutFailureUrl = 'https://musesessions.co/spark'

// { regionClass: 'south_america' | 'other' }
let regionClass = 'other'

const priceIdMatrix = {
    // regionClass
    other: {
        starter: {
            monthly: 'price_1NpwoOJYJ1xBqV1YSSljd05p',
            annually: 'price_1NpyQCJYJ1xBqV1YbCdQd5hC'
        },
        creator: {
            monthly: 'price_1NpxroJYJ1xBqV1Y09mLnZMn',
            annually: 'price_1NpyWnJYJ1xBqV1YTmXUEXXq'
        },
        pro: {
            monthly: 'price_1NpxxSJYJ1xBqV1YPiY3ee9O',
            annually: 'price_1Npya9JYJ1xBqV1Ya7Pn3qRJ'
        }
    },
    south_america: {
        starter: {
            monthly: 'price_1NpwoOJYJ1xBqV1YoZXz3cNQ',
            annually: 'price_1Npyn2JYJ1xBqV1YqieXkJxg'
        },
        creator: {
            monthly: 'price_1NpxroJYJ1xBqV1YG3Sz6PZu',
            annually: 'price_1NpyWnJYJ1xBqV1YL2KWhpAx'
        },
        pro: {
            monthly: 'price_1NpxxSJYJ1xBqV1YmwbgLe0n',
            annually: 'price_1Npya9JYJ1xBqV1YH0MWKN7G'
        }
    }
}

const priceMatrix = {
    // IN: {
    //     starter: {
    //         monthly: '1.2/month',
    //         annually: '12 (2 months free)'
    //     },
    //     creator: {
    //         monthly: '2/month',
    //         annually: '20 (2 months free)'
    //     },
    //     pro: {
    //         monthly: '2.79/month',
    //         annually: '28 (2 months free)'
    //     }
    // },
    // NG: {
    //     starter: {
    //         monthly: '1.45/month',
    //         annually: '14.54 (2 months free)'
    //     },
    //     creator: {
    //         monthly: '2.42/month',
    //         annually: '24.23 (2 months free)'
    //     },
    //     pro: {
    //         monthly: '3.39/month',
    //         annually: '33.92 (2 months free)'
    //     }
    // },
    IN: {
        starter: {
            monthly: '₹100/month',
            annually: '₹1,000 (2 months free)'
        },
        creator: {
            monthly: '₹166/month',
            annually: '₹1,660 (2 months free)'
        },
        pro: {
            monthly: '₹232/month',
            annually: '₹2,323 (2 months free)'
        }
    },
    NG: {
        starter: {
            monthly: '₦1,120/month',
            annually: '₦11,200 (2 months free)'
        },
        creator: {
            monthly: '₦1,866/month',
            annually: '₦18,667 (2 months free)'
        },
        pro: {
            monthly: '₦2,613.38/month',
            annually: '₦26,133.80 (2 months free)'
        }
    },
    'AR,BO,BR,CL,CO,EC,GY,PY,PE,SR,UY,VE': {
        starter: {
            monthly: '$2.99/month',
            annually: '$29.99 (2 months free)'
        },
        creator: {
            monthly: '$4.99/month',
            annually: '$49.99 (2 months free)'
        },
        pro: {
            monthly: '$6.99/month',
            annually: '$69.99 (2 months free)'
        }
    }
}

window.onload = () => {
    console.log('spark.js loaded.')

    try {
        const user = getLoggedInUser()
        if (user) {
            logUserActivity('SPARK_PAGE_VIEW', user.username, user)
        } else {
            logUserActivity('GUEST_SPARK_PAGE_VIEW')
        }
    } catch (error) {
        console.error('Error in Analytics:', error)
    }

    function changePriceLabel(countryCode) {
        let p = null
        Object.keys(priceMatrix).forEach((cc => {
            if ( cc.split(',').includes(countryCode) ) {
                p = priceMatrix[cc]
            }
        }))

        if (p) {
            // update price tag
            $('#pricetag_starter_monthly').text(p.starter.monthly)
            $('#pricetag_creator_monthly').text(p.creator.monthly)
            $('#pricetag_pro_monthly').text(p.pro.monthly)

            $('#pricetag_starter_annually').text(p.starter.annually)
            $('#pricetag_creator_annually').text(p.creator.annually)
            $('#pricetag_pro_annually').text(p.pro.annually)
        }
    }

    $('#spark-version').text('Spark version ')
    getAppRuntimeConstants()
    .then(response => {
        const { app_latest_version, spark_latest_version } = response
        $('#spark-version').text('Spark version ' + spark_latest_version)

        updateDownloadLinksWithVersion(app_latest_version, spark_latest_version)
    })

    getIpInfo().then((data) => {
        /* { status: 'success'|'fail' } */
        const { status, countryCode } = data
        console.log('ip-info response: %O', data)

        if (status === 'fail') {
            return
        }

        // set `regionClass` global variable
        regionClass = countryCodeToRegionClass(countryCode)

        // use priceMatrix to set price text.
        changePriceLabel(countryCode)
    })
    .catch(e => {
        // failed to get ip info.
        console.error(e)
    })

    const getPlanDurationType = () => {
        const c1 = $('div[class="pricing-verticals annually"][style="display: flex;"]').length > 0
        const c2 = $('div[class="pricing-verticals annually"][style="display:flex"]').length > 0
        if (c1 || c2) {
            return 'annually'
        } else {
            return 'monthly'
        }
    }

    const getStripePriceId = (planType, planDurationType, regionClass) => {
        try {
            return priceIdMatrix[regionClass][planType][planDurationType]
        } catch(e) {
            console.error('failed to get price id. error: ' + e.message)
        }
    }

    const generateCheckoutLinkOrRedirect = async (priceId) => {
        const user = getLoggedInUser()
        const authToken = getAuthToken()

        // const promotionCode = 'promo_1OEj1VJYJ1xBqV1Y7KIvbOQt' // BLACKFRIDAY
        const promotionCode = null
        if (user) {
            // if logged in user, then simply get the checkout link from the api and 
            // go to the link.
            const checkoutLink = await fetchCheckoutLink(
                priceId, authToken, checkoutSuccessUrl, checkoutFailureUrl, promotionCode)
            return checkoutLink
        } else {
            // if not, then they go to the login page, with appropriate url params
            // to redirect them to the checkout link after they are done.
            const actionAfterLogin = btoa(JSON.stringify({
                op: 'stripeCheckout',
                priceId: priceId,
                successUrl: checkoutSuccessUrl,
                failureUrl: checkoutFailureUrl,
                promotionCode,
            }));
            const url = `login?actionAfterLogin=${actionAfterLogin}`
            return url
        }
    }

    const handleGenerateLinkAndRedirect = async (ev, type) => {
        try {
            const planDurationType = getPlanDurationType()
            console.log(`type="${type}" clicked. planDurationType=%O`, planDurationType)

            console.log(`call stripePriceId: type=${type} planDurationType=${planDurationType} regionClass=${regionClass}`)
            const stripePriceId = getStripePriceId(type, planDurationType, regionClass)
            console.log(`got stripePriceId=${stripePriceId}`)

            const link = await generateCheckoutLinkOrRedirect(stripePriceId)

            window.location.href = link
        } catch(e) {
            alert(`There was an error during checkout. Please contact support. message: "${e.message}"`)
        }
    }

    $('a:contains("Choose Starter")').on('click', function (ev) {
        handleGenerateLinkAndRedirect(ev, 'starter')
    })

    $('a:contains("Choose Creator")').on('click', function (ev) {
        handleGenerateLinkAndRedirect(ev, 'creator')
    })

    $('a:contains("Choose Pro")').on('click', function (ev) {
        handleGenerateLinkAndRedirect(ev, 'pro')
    })

    $('a:contains("Choose Starter")').attr({
        'target': '_blank',
        'rel': 'noopener noreferrer'
    })
    $('a:contains("Choose Creator")').attr({
        'target': '_blank',
        'rel': 'noopener noreferrer'
    })
    $('a:contains("Choose Pro")').attr({
        'target': '_blank',
        'rel': 'noopener noreferrer'
    })

    let isSending = false
    $('#edit-account-btn').on('click', (ev) => {
        ev.preventDefault()

        $('#error-text').css('display', 'none')

        function disableButton() {
            $('#edit-account-btn')
                .css('pointer-events', 'none')
                .css('opacity', '0.75')
            isSending = true
        }
        function enableButton() {
            $('#edit-account-btn')
                .css('pointer-events', 'auto')
                .css('opacity', '1')
            isSending = false
        }
        function removeButton() {
            $('#edit-account-btn').css('display', 'none')
        }

        const email = $('#email-signup').val()

        // disable button from further clicks
        disableButton()

        console.log(`POST`)
        if ((email||'').trim().length === 0) {
            alert(`Please specify an email.`)
            enableButton()
            return
        }

        $.ajax({
            method: 'POST',
            url: `${window.apiHost}/api/v1/requests/download-app-email`,
            data: JSON.stringify({ email: email }),
            dataType: 'json',
            contentType: 'application/json',
            error: response => {
                alert(`Sorry, there was an error while processing the request.`)
                enableButton()
            },
            success: response => {
                $('#success-message').css('display', 'block')
                $('#success-message > div').css('color', '#161616')
                removeButton()
            },
        })
    })
}
